import DisplayOnlyFieldComponent from './display-only-field-component';

/***
 * a field for rendering the label and value that is un-editable.
 */
const displayOnlyField = angular
    .module('FacilityData.ClientEdit.FormFields.DisplayOnlyField', [])
    .component('displayOnlyField', DisplayOnlyFieldComponent)
    .name;

export default displayOnlyField;


// WEBPACK FOOTER //
// ./app/common/form-fields/display-only-field/display-only-field.js